{
  "label": "Gerät",
  "name": "Name",
  "model": "Modell",
  "type": "Typ",
  "serialNumber": "Seriennummer",
  "sector": "Sektor",
  "connectivity": "Konnektivität",
  "certificate": "Zertifikat",
  "state": "Status",
  "states": {
    "activated": "Aktiviert",
    "deactivated": "Deaktiviert",
    "registered": "Neu"
  },
  "actions": {
    "scheduled": {
      "title": "Sind Aktionen in Bearbeitung?",
      "yes": "Ja",
      "no": "Nein",
      "error": "Nicht definiert"
    }
  },
  "firmwareVersion": "Firmware-Version",
  "hardwareVersion": "Hardware-Version",
  "updateCertificate": "Zertifikat aktualisieren",
  "updateFirmware": "Firmware aktualisieren",
  "updateState": {
    "activate": {
      "title": "Aktivieren",
      "execute": "Gerät aktivieren",
      "description": "Gerät {name} wird aktiviert."
    },
    "deactivate": {
      "title": "Deaktivieren",
      "execute": "Gerät deaktivieren",
      "description": "Gerät {name} wird deaktiviert.",
      "warning": "Ein deaktiviertes Gerät profitiert nicht mehr von automatischen und manuellen Zertifikatsaktualisierungen.",
      "error": "Dieses Gerät kann nicht deaktiviert werden, da ein Vorgang geplant ist oder ausgeführt wird."
    }
  },
  "month": "{n} Monat | {n} Monate",
  "year": "{n} Jahr | {n} Jahre",
  "custom": "Benutzerdefiniert",
  "dateFormat": "YYYY/MM/DD hh:mm A",
  "empty": "Kein Gerät gefunden",
  "delete": {
    "execute": "Gerät löschen",
    "description": "Gerät {name} wird gelöscht.",
    "warning": "Die mit dem Gerät verbundenen Vorgänge werden ebenfalls gelöscht.",
    "error": "Dieses Gerät kann nicht gelöscht werden, da ein Vorgang geplant ist oder ausgeführt wird."
  },
  "description": {
    "title": "Beschreibung",
    "idCard": "ID-Karte",
    "state": "Status",
    "connectivity": "Konnektivität",
    "lastConnection": "Letzte Verbindung",
    "certificateValidityDate": "Gültigkeitsdatum des Zertifikats",
    "lastChange": "Letzte Änderung",
    "configurationApplicationDate": "Datum der Parametrierungsanwendung",
    "lastRebootDate": "Datum des letzten Neustarts",
    "firstCommissioningDate": "Datum der ersten Inbetriebnahme",
    "lastFirmwareUpdate": "Letztes Firmware-Update",
    "mobileNetwork": "Mobilfunknetz",
    "gsmFrequencyBand": "GSM-Frequenzband",
    "communicationProtocol": "Kommunikationsprotokoll"
  },
  "certificateForm": {
    "expirationDate": "Ablaufdatum des Zertifikats",
    "certificateOrigin": "Herkunft des Zertifikats",
    "lastUpdate": "Letzte Aktualisierung des Zertifikats"
  },
  "firmwareForm": {
    "title": "Firmware",
    "version": "Version",
    "description": "Firmwarebeschreibung",
    "origin": "Herkunft der Firmware",
    "lastUpdate": "Zuletzt aktualisiert"
  },
  "configurationForm": {
    "title": "Parametrierung"
  },
  "operation": {
    "cancel": {
      "tooltip": {
        "enabled": "Vorgang abbrechen",
        "disabled": "Sie können den Vorgang nicht abbrechen"
      },
      "confirm": {
        "title": "Abbrechen des Vorgangs",
        "description": "Dieser Vorgang wird abgebrochen. Der Abbruch kann nicht rückgängig gemacht werden."
      }
    },
    "unitary": "Einzeln",
    "campaign": "Kampagne",
    "update": {
      "tooltip": {
        "enabled": "Vorgang aktualisieren",
        "disabled": "Sie können den Vorgang nicht aktualisieren"
      }
    }
  },
  "additionalMetadata": {
    "title": "Zusätzliche Metadaten",
    "options": {
      "title": "Optionen",
      "software": {
        "1": "Programmbaustein",
        "2": "Pumpstationen",
        "3": "WEB Server",
        "4": "Übersicht grafische Darstellung der Website",
        "5": "IP-Backup ADSL/GSM",
        "6": "IEC60870-5-104 Slave"
      },
      "numericSoftware": {
        "1": "Anzahl der Datenpunkte: {value}",
        "2": "Anzahl der E/A-Module: {value}",
        "3": "Anzahl der COM-Module: {value}"
      }
    },
    "communicationModules": {
      "title": "Kommunikationsmodule"
    },
    "modulesIo": {
      "title": "Module E/A"
    },
    "modules": {
      "location": "Position",
      "module": "Modul"
    }
  },
  "warningMessage": "Für das Gerät ist bereits ein Vorgang desselben Typs geplant oder wird bereits ausgeführt"
}
